import { render, staticRenderFns } from "./user_message.vue?vue&type=template&id=14654e67&scoped=true"
import script from "./user_message.vue?vue&type=script&lang=js"
export * from "./user_message.vue?vue&type=script&lang=js"
import style0 from "./user_message.vue?vue&type=style&index=0&id=14654e67&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14654e67",
  null
  
)

export default component.exports